import React, { useState, useEffect } from 'react';
import AuthHeader from './Header';
import { UserAccountContext } from '../../contextHooks';
import { ValidateSessionTokenAPI } from '../../helper/services/API/Users';
import Snackbar from '../../components/Snackbar/Snackbar';
import Loader from '../../helper/loaders/ComponentLoader';
import {getSessionToken} from "../../utils/authentication/jwtUtils";
import { setCookieStorage } from "../../utils/CookieLocalStorage";

const AuthLayout = (props) => {
    //const { children } = props;
    //const childrenProps = children.props;

    const [userAccount, setUserAccount] = useState({});
    const [snackbarState, setSnackbarState] = useState({
        messageInfo: {
            open: false,
            message: null,
            variant: 'success'
        }
    });

    const setUserDataContext = (res) =>{
        if(res.success && res.data){
            setUserAccount(res.data);
        }
        else if (res.message_code === 30001) {
            setSnackbarState({
                messageInfo: {
                    open: true,
                    message: res.message,
                    variant: 'error'
                }
            });
            setCookieStorage('session_token', null, { path: '/', sameSite: true });
            window.location = "/auth/login";
        }
        else {
            setSnackbarState({
                messageInfo: {
                    open: true,
                    message: 'Something went wrong!',
                    variant: 'error'
                }
            });
        }
    }

    useEffect(()=>{
        ValidateSessionTokenAPI().then((res)=>{
            setUserDataContext(res);
            
            if (!getSessionToken()) {
                window.location = "/auth/login";
            }
        }).catch((error)=>{
            console.log(error);
            setSnackbarState({
                messageInfo: {
                    open: true,
                    message: 'Something went wrong!',
                    variant: 'error'
                }
            });
        });
    },[props.children.props]);

    return (
        <React.Fragment>
            {snackbarState.messageInfo.open && <Snackbar
                message={snackbarState.messageInfo.message}
                open={snackbarState.messageInfo.open}
                closeSnackBar={() => {
                    setSnackbarState({ messageInfo: { open: false, message: null, variant: 'success' } });
                }}
                variant={snackbarState.messageInfo.variant}
                autoHideDuration={5000}
            />}
            {
                Object.keys(userAccount).length > 0 ?
                    <React.Fragment>
                        <UserAccountContext.Provider value={userAccount}>
                            <AuthHeader 
                                prps = {props.children.props}
                            />
                            {props.children}
                        </UserAccountContext.Provider>
                        {/* <Footer /> */}
                    </React.Fragment>
                    : 
                    <Loader />
            }
        </React.Fragment>
    );
}

export default AuthLayout;